export default {
  message: { //葡萄牙
    "strid1": "Conecte-se",
    "strid2": "Anúncio",
    "strid3": "Mais",
    "strid4": "Inquérito de penalidade",
    "strid5": "Report inquery",
    "strid6": "Anúncio de penalidade",
    "strid7": "Ciência de Segurança",
    "strid8": "Regras de penalidade",
    "strid9": "Hora do relatório",
    "strid10": "Reportar jogador",
    "strid11": "Motivo do relatório",
    "strid12": "Resultado do relatório",
    "strid13": "Aceitaram",
    "strid14": "Violação",
    "strid15": "Tempo de penalidade",
    "strid16": "Razão da penalidade",
    "strid17": "Tempo de desbloqueio",
    "strid18": "Recurso",
    "strid19": "Apelou",
    "strid20": "Verificando",
    "strid21": "O recurso falhou",
    "strid22": "Resultado da apelação",
    "strid23": "Apelação bem-sucedida",
    "strid24": "pronto",
    "strid25": "Formulário de apelação",
    "strid26": "Possíveis razões para punição",
    "strid27": "Endereço de download de software de vídeo / imagem / plug-in",
    "strid28": "Descrição",
    "strid29": "sistema de autoatendimento",
    "strid30": "Apelidos",
    "strid31": "ID da conta",
    "strid32": "Nível",
    "strid33": "Classificação",
    "strid34": "Duração do jogo",
    "strid35": "Modelo de telefone",
    "strid36": "Caixa de correio",
    "strid37": "Binding AccountID （google, fb ou vk）",
    "strid38": "Antes de recorrer, você precisa preencher as informações de sua conta e informações de contato para que possamos entrar em contato com você",
    "strid39": "Minha conta foi roubada.",
    "strid40": "Eu não trapaceei, minha conta só foi usada por mim.",
    "strid41": "Admito que trapaceei e não farei de novo.",
    "strid42": "Por favor, insira ",
    "strid43": "Contate o Atendimento ao Cliente",
    "strid44": 'eu sei',
    "strid45": 'Não',
    "strid46": 'Por favor preencha o formulário',
  }
}

